"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.KEYPAD_NUMBER_9 = exports.KEYPAD_NUMBER_8 = exports.KEYPAD_NUMBER_7 = exports.KEYPAD_NUMBER_6 = exports.KEYPAD_NUMBER_5 = exports.KEYPAD_NUMBER_4 = exports.KEYPAD_NUMBER_3 = exports.KEYPAD_NUMBER_2 = exports.KEYPAD_NUMBER_1 = exports.KEYPAD_NUMBER_0 = exports.NUMBER_9 = exports.NUMBER_8 = exports.NUMBER_7 = exports.NUMBER_6 = exports.NUMBER_5 = exports.NUMBER_4 = exports.NUMBER_3 = exports.NUMBER_2 = exports.NUMBER_1 = exports.NUMBER_0 = exports.Z = exports.Y = exports.UP = exports.SPACE = exports.RIGHT = exports.NBSP = exports.LEFT = exports.ESC = exports.TAB = exports.ENTER = exports.DOWN = exports.BRACKET_RIGHT = exports.BRACKET_LEFT = exports.BACKSPACE = void 0;
var BACKSPACE = 8;
exports.BACKSPACE = BACKSPACE;
var BRACKET_LEFT = 219;
exports.BRACKET_LEFT = BRACKET_LEFT;
var BRACKET_RIGHT = 221;
exports.BRACKET_RIGHT = BRACKET_RIGHT;
var DOWN = 40;
exports.DOWN = DOWN;
var ENTER = 13;
exports.ENTER = ENTER;
var TAB = 9;
exports.TAB = TAB;
var ESC = 27;
exports.ESC = ESC;
var LEFT = 37;
exports.LEFT = LEFT;
var NBSP = 160;
exports.NBSP = NBSP;
var RIGHT = 39;
exports.RIGHT = RIGHT;
var SPACE = 32;
exports.SPACE = SPACE;
var UP = 38;
exports.UP = UP;
var Y = 89;
exports.Y = Y;
var Z = 90;
exports.Z = Z;
var NUMBER_0 = 48;
exports.NUMBER_0 = NUMBER_0;
var NUMBER_1 = 49;
exports.NUMBER_1 = NUMBER_1;
var NUMBER_2 = 50;
exports.NUMBER_2 = NUMBER_2;
var NUMBER_3 = 51;
exports.NUMBER_3 = NUMBER_3;
var NUMBER_4 = 52;
exports.NUMBER_4 = NUMBER_4;
var NUMBER_5 = 53;
exports.NUMBER_5 = NUMBER_5;
var NUMBER_6 = 54;
exports.NUMBER_6 = NUMBER_6;
var NUMBER_7 = 55;
exports.NUMBER_7 = NUMBER_7;
var NUMBER_8 = 56;
exports.NUMBER_8 = NUMBER_8;
var NUMBER_9 = 57;
exports.NUMBER_9 = NUMBER_9;
var KEYPAD_NUMBER_0 = 96;
exports.KEYPAD_NUMBER_0 = KEYPAD_NUMBER_0;
var KEYPAD_NUMBER_1 = 97;
exports.KEYPAD_NUMBER_1 = KEYPAD_NUMBER_1;
var KEYPAD_NUMBER_2 = 98;
exports.KEYPAD_NUMBER_2 = KEYPAD_NUMBER_2;
var KEYPAD_NUMBER_3 = 99;
exports.KEYPAD_NUMBER_3 = KEYPAD_NUMBER_3;
var KEYPAD_NUMBER_4 = 100;
exports.KEYPAD_NUMBER_4 = KEYPAD_NUMBER_4;
var KEYPAD_NUMBER_5 = 101;
exports.KEYPAD_NUMBER_5 = KEYPAD_NUMBER_5;
var KEYPAD_NUMBER_6 = 102;
exports.KEYPAD_NUMBER_6 = KEYPAD_NUMBER_6;
var KEYPAD_NUMBER_7 = 103;
exports.KEYPAD_NUMBER_7 = KEYPAD_NUMBER_7;
var KEYPAD_NUMBER_8 = 104;
exports.KEYPAD_NUMBER_8 = KEYPAD_NUMBER_8;
var KEYPAD_NUMBER_9 = 105;
exports.KEYPAD_NUMBER_9 = KEYPAD_NUMBER_9;